import { CascaderSelect } from '@alifd/next';
import wrapper from './next-wrapper';
const FormCascaderSelect = wrapper(CascaderSelect, 'CbayelFormCascaderSelect');
export default FormCascaderSelect;
